// extracted by mini-css-extract-plugin
export default {"default":"Link_default__v38rM","md":"Link_md__ymjPa","lg":"Link_lg__CIXvn","border":"Link_border__A3Nux"};